import React from 'react'
import {money} from './financeReport.mjs'
export default function StoreIncoming({data,compact=false}){
 const shopify=data.shopify,au=data.au,shopifyReady=shopify?.status==='ready',auReady=au?.status==='ready'
 return <section className={compact?'ag-finance-stat ag-store-incoming':'ag-finance-card ag-store-incoming'} aria-label="Store Incoming">
  <h2>Store Incoming</h2>
  <dl><div><dt>Shopify receipts<small>After customer refunds</small></dt><dd>{shopifyReady?money(shopify.netCents):'Unavailable'}</dd></div>
  <div><dt>AU estimated profit<small>Current gold value − purchase cost</small></dt><dd>{auReady?money(au.estimatedProfitCents):'Unavailable'}</dd></div></dl>
  <details><summary>View sources and calculation</summary>
   <p>{shopifyReady?`Received ${money(shopify.receivedCents)} · refunded ${money(shopify.refundCents)}.`:shopify?.message||'Shopify receipts have not been loaded.'}</p>
   <p>{au?.message||'AU records have not been loaded in this preview.'}</p>
   {au?.purchaseCostCents!=null&&<p>AU purchased: {money(au.purchaseCostCents)} · {au.purchaseCount} purchases{au.marketValueCents!=null?` · current value ${money(au.marketValueCents)}`:''}.</p>}
   <p>The AU result is an unrealized estimate, not proceeds from a sale. These two sources are shown separately and are not combined into a cash total.</p>
  </details>
 </section>
}
